import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight, Lock, ShoppingCart, Sparkles } from 'lucide-react';
export function FinalCTASection() {
  return <section className="py-24 bg-gradient-to-br from-brand-navy via-brand-navy to-brand-navy-light text-white text-center px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-113">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-114">
        <div className="absolute top-10 right-10 w-96 h-96 bg-brand-red/10 rounded-full blur-3xl" data-id="element-115"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-brand-yellow/10 rounded-full blur-3xl" data-id="element-116"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 px-4 sm:px-6" data-id="element-117">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 font-serif leading-tight" data-id="element-118">
          Haz clic ahora. Y deja que hoy sea el primer día{' '}
          <br className="hidden md:block" data-id="element-119" />
          <span className="text-brand-yellow" data-id="element-120">
            sin lucha, sin culpa, sin pantallas.
          </span>
        </h2>

        <p className="text-lg sm:text-xl text-brand-cream/90 mb-8 sm:mb-10 max-w-2xl mx-auto" data-id="element-121">
          El caos no va a desaparecer solo. Pero tú puedes tener la herramienta
          para controlarlo en minutos.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-122">
          {/* PREMIUM LUXURY CTA BUTTON */}
          <div className="relative group w-full max-w-2xl" style={{
          perspective: '1000px'
        }} data-id="element-123">
            {/* Outer multicolor glow - pulsating */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#FFD700] via-[#FF6B6B] via-[#4ECDC4] to-[#9D50BB] rounded-2xl blur-lg opacity-60 group-hover:opacity-90 transition duration-500 animate-pulse" data-id="element-124"></div>

            {/* Pulsating gradient border - soft shimmer */}
            <div className="absolute -inset-0.5 bg-gradient-to-r from-[#FFD700] via-[#FF6B6B] via-[#4ECDC4] via-[#9D50BB] to-[#FFD700] rounded-xl opacity-75 group-hover:opacity-100 transition duration-300 animate-[shimmer_2s_ease-in-out_infinite]" data-id="element-125"></div>

            <a href="https://mikioscodigital.com/checkout?variant=51784383398169&quantity=1" className="relative w-full bg-gradient-to-br from-[#FCD34D] to-[#FBBF24] hover:from-[#FBBF24] hover:to-[#F59E0B] rounded-xl transition-all duration-300 overflow-hidden block touch-manipulation" style={{
            transform: 'translateZ(0)',
            boxShadow: '0 10px 30px -5px rgba(251, 191, 36, 0.5), 0 20px 40px -10px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -2px 0 rgba(0, 0, 0, 0.2)'
          }} onMouseEnter={e => {
            if (window.innerWidth >= 768) {
              e.currentTarget.style.transform = 'translateY(-4px) translateZ(20px) rotateX(2deg)';
              e.currentTarget.style.boxShadow = '0 20px 50px -5px rgba(251, 191, 36, 0.7), 0 30px 60px -15px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -2px 0 rgba(0, 0, 0, 0.2)';
            }
          }} onMouseLeave={e => {
            e.currentTarget.style.transform = 'translateZ(0)';
            e.currentTarget.style.boxShadow = '0 10px 30px -5px rgba(251, 191, 36, 0.5), 0 20px 40px -10px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.4), inset 0 -2px 0 rgba(0, 0, 0, 0.2)';
          }} data-id="element-126">
              {/* Top highlight for 3D effect */}
              <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-white/30 to-transparent rounded-t-xl pointer-events-none" data-id="element-127"></div>

              {/* Bottom shadow for depth */}
              <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-black/20 to-transparent rounded-b-xl pointer-events-none" data-id="element-128"></div>

              {/* Animated shine effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" data-id="element-129"></div>

              {/* Sparkle particles */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-130">
                <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" data-id="element-131"></div>
                <div className="absolute top-1/2 right-1/4 w-2 h-2 bg-[#4ECDC4] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                animationDelay: '0.2s'
              }} data-id="element-132"></div>
                <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-[#FF6B6B] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                animationDelay: '0.4s'
              }} data-id="element-133"></div>
                <div className="absolute top-3/4 right-1/3 w-2 h-2 bg-[#9D50BB] rounded-full opacity-0 group-hover:opacity-100 group-hover:animate-ping" style={{
                animationDelay: '0.6s'
              }} data-id="element-134"></div>
              </div>

              <div className="relative px-4 sm:px-6 md:px-8 py-4 sm:py-5" data-id="element-135">
                <div className="flex items-center justify-center gap-2 sm:gap-3" data-id="element-136">
                  <ShoppingCart className="w-5 h-5 sm:w-6 sm:h-6 text-[#1e3a8a] group-hover:scale-110 transition-transform duration-300 drop-shadow-[0_2px_8px_rgba(30,58,138,0.4)] flex-shrink-0" strokeWidth={2.5} data-id="element-137" />
                  <span className="text-sm sm:text-base md:text-lg font-bold text-[#1e3a8a] drop-shadow-[0_2px_4px_rgba(30,58,138,0.2)] text-center leading-tight" data-id="element-138">
                    QUIERO MI PACK PREMIUM AHORA
                  </span>
                  <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-[#1e3a8a] group-hover:rotate-12 transition-transform duration-300 drop-shadow-[0_2px_8px_rgba(30,58,138,0.4)] flex-shrink-0" strokeWidth={2.5} data-id="element-139" />
                </div>
              </div>

              {/* Bottom glow */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3/4 h-4 bg-gradient-to-r from-transparent via-[#FBBF24] to-transparent blur-xl opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-140"></div>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-6 mt-4 sm:mt-6 text-xs sm:text-sm text-brand-cream/70" data-id="element-141">
            <span className="flex items-center gap-1" data-id="element-142">
              <Lock className="w-3 h-3 flex-shrink-0" data-id="element-143" /> Pago seguro
            </span>
            <span className="hidden sm:inline" data-id="element-144">•</span>
            <span data-id="element-145">Acceso inmediato</span>
            <span className="hidden sm:inline" data-id="element-146">•</span>
            <span data-id="element-147">Garantía 30 días</span>
          </div>
        </div>
      </div>

      <style jsx data-id="element-148">{`
        @keyframes shimmer {
          0%,
          100% {
            opacity: 0.5;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
    </section>;
}